import { Spinner } from "@hackthenorth/north";
import React from "react";
import styled from "styled-components";

import { Icon } from "src/shared/components";
import { useHackerContext } from "src/shared/contexts";
import { RsvpAutosaveStatus } from "src/shared/contexts/HackerContext/autosave";
import { CheckIcon } from "src/static/icons";

const AutosaveStatus: React.FC = () => {
  const { autosaveStatus } = useHackerContext();
  const isPending = autosaveStatus === RsvpAutosaveStatus.PENDING;
  const isSaving = autosaveStatus === RsvpAutosaveStatus.SAVING;
  const isSaved = autosaveStatus === RsvpAutosaveStatus.SAVED;
  const hasError = autosaveStatus === RsvpAutosaveStatus.ERROR;
  const label = hasError ? "Failed to save" : isSaved ? "Saved" : "Saving";

  return (
    <StatusRow
      role="status"
      aria-live="polite"
      title={hasError ? "We couldn't save your latest changes." : undefined}
    >
      <StatusIcon>
        {isSaving ? (
          <Spinner size={18} color="currentColor" />
        ) : isPending ? (
          <PendingDots aria-hidden>
            <span />
            <span />
            <span />
          </PendingDots>
        ) : isSaved ? (
          <CheckIcon width={18} height={18} aria-hidden />
        ) : (
          <Icon
            name={hasError ? "error-circle" : "clock"}
            color={hasError ? "textDanger" : "textTertiary"}
            width={18}
            height={18}
          />
        )}
      </StatusIcon>
      <StatusText hasError={hasError}>{label}</StatusText>
    </StatusRow>
  );
};

export default AutosaveStatus;

const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 24px;
  margin-top: 24px;
  color: ${({ theme }) => theme.globalConstants.color.textTertiary};
`;

const StatusIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  flex-shrink: 0;
`;

const PendingDots = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;

  span {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: currentColor;
  }
`;

const StatusText = styled.span<{ hasError: boolean }>`
  color: ${({ hasError, theme }) =>
    hasError
      ? theme.globalConstants.color.textDanger
      : theme.globalConstants.color.textTertiary};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;
